export default __webpack_public_path__ + "static/media/contact1.69baa4b1.jpg";